module.exports = __webpack_public_path__ + "img/how4.ab836416.png";